import { render, staticRenderFns } from "./ComunicacaoTransferenciaExecucaoFiscalSefa.vue?vue&type=template&id=9e41e390&"
import script from "./ComunicacaoTransferenciaExecucaoFiscalSefa.vue?vue&type=script&lang=js&"
export * from "./ComunicacaoTransferenciaExecucaoFiscalSefa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports